$(function() {

  let tickerItems = $(".ev-header__pr");
  let prCurrentIndex = 0;
  let animationDuration = 600;
  let displayDuration = 4000;

  function showTickerItem(index) {
    tickerItems.eq(index).css({ display: "flex", top: "100%", opacity: "1" }).addClass('active').animate({ top: "0%" },
      animationDuration,
      function() {
        setTimeout(function() {
          tickerItems.eq(index).animate({ top: "-100%", opacity: "0" },
            animationDuration,
            function() {
              tickerItems.eq(index).removeClass('active').css("display", "none");
              prCurrentIndex = (prCurrentIndex + 1) % tickerItems.length;
              showTickerItem(prCurrentIndex);
            }
          );
        }, displayDuration);
      }
    );
  }

  // 最初のティッカーアイテムを表示
  showTickerItem(prCurrentIndex);

  const $noTickerWrapper = $(".no-ticker");
  const $noTickerItems = $(".no-ticker__item");
  const noItemHeight = $noTickerItems.outerHeight();

  let noCurrentIndex = 0;

  const $titleTickerWrapper = $(".title-ticker");
  const $titleTickerItems = $(".title-ticker__item");
  const titleItemHeight = $titleTickerItems.outerHeight();
  const titleTotalItems = $titleTickerItems.length;

  let titleCurrentIndex = 0;

  const $tickerWrapper = $(".image-ticker");
  const $tickerItems = $(".image-ticker__item");
  const totalItems = $tickerItems.length;
  let currentIndex = 0;

  // アイテムの高さを取得
  const itemHeight = $tickerItems.outerHeight(true); // outerHeightでマージン込みの高さを取得

  // スライドのアニメーション
  function slideAndScrollTicker() {
    // ノンティッカー
    noCurrentIndex = (noCurrentIndex + 1) % $noTickerItems.length;
    $noTickerWrapper.css("transform", `translateY(-${noItemHeight * noCurrentIndex}px)`);

    // 次のアイテムにスライド
    currentIndex = (currentIndex + 1) % totalItems; // 最後までいったら最初に戻る
    titleCurrentIndex = (titleCurrentIndex + 1) % titleTotalItems; // 最後までいったら最初に戻る

    // 他のアイテムのz-indexを調整
    $titleTickerWrapper.find(".title-ticker__item").not(':eq(' + titleCurrentIndex + ')').css({
      "z-index": "10",
      "opacity": "0",
      "transform": "translateY(-20px)",
    }).removeClass('active');

    // 現在のアイテムだけアニメーションさせる
    $titleTickerWrapper.find(".title-ticker__item").eq(titleCurrentIndex).css({
      "z-index": "11", // 現在のアイテムを最前面に
      "transition": "transform 0.8s ease, opacity 0.5s ease",
      "transform": "translateY(0%)",
      "opacity": "1",
    }).addClass('active');

    // 現在のアイテムだけアニメーションさせる
    $tickerWrapper.find(".image-ticker__item").eq(currentIndex).css({
      "z-index": "11", // 現在のアイテムを最前面に
      "transition": "transform 0.8s ease, opacity 0.5s ease",
      "transform": "translateY(0%)",
    });

    // 他のアイテムのz-indexを調整
    $tickerWrapper.find(".image-ticker__item").not(':eq(' + currentIndex + ')').css({
      "z-index": "10",
    });

    // 他のアイテムを遅延させて、非表示にする
    setTimeout(function() {
      $titleTickerWrapper.find(".title-ticker__item").not(':eq(' + titleCurrentIndex + ')').css({
        "transform": "translateY(100%)",
      });
      $tickerWrapper.find(".image-ticker__item").not(':eq(' + currentIndex + ')').css({
        "transform": "translateY(100%)",
      });
    }, 800);
  }

  $(".pickup").find('.title-ticker__item:first-child').addClass('active');

  $(".pickup").on("click", function() {
    var link = $(this).find('.title-ticker__item.active a').attr('href');
    if (link) {
      window.location.href = link;
    } else {
      console.error("リンクが見つかりません");
    }
  });

  $('.template-index .ev-header').css({
    "top": "0",
  });

  $(".ev-mv").on("init", function() {
      $(this).addClass('active');
      $('.slick-slide[data-slick-index="0"]').addClass("add-animation-first");
    })
    .slick({
      dots: false,
      arrows: false,
      infinite: true,
      fade: true,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 6000,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      slide: '.mv',
    })
    .on({
      beforeChange: function(event, slick, currentSlide, nextSlide) {
        $(".slick-slide", this).eq(nextSlide).addClass("add-animation");
        $(".slick-slide", this).eq(currentSlide).addClass("remove-animation");
        slideAndScrollTicker();
      },
      afterChange: function() {
        $(this).slick("slickSetOption", "autoplaySpeed", 5000);
        $(".remove-animation", this).removeClass(
          "remove-animation add-animation add-animation-first"
        );
      },
    });

    $('.mv').click(function(){
      var linkURL = $('.title-ticker__item.active').find('a').attr('href');
      //console.log(linkURL);
      window.location.href = linkURL;
    });

  $('.nav__item > a,.ev-footer__nav > li > a,.link--standard > span,.link--primary > span,.link--border > span,.list-subnav__item > a > span').each(function() {
    const $this = $(this);
    const text = $this.text();
    const spannedText = text.split('').map(char => `<span>${char}</span>`).join('');
    $this.html(spannedText);
  });

  // ナビゲーションクリックイベント
  $('.nav__item:not(.nav__item--single) > a').click(function() {
    $(this).toggleClass('active');
    $(this).next('ul').toggleClass('active');
    $('.nav__item:not(.nav__item--single) > a').not(this).removeClass('active');
    $('.nav__item:not(.nav__item--single) > ul').not($(this).next('ul')).removeClass('active');
    return false;
  });

  // メニューアイコンクリックイベント
  $('.nav-icon__item--menu').click(function() {
    $(this).add('body').toggleClass('active');
    if ($('.ev-header,.ev-drawer').hasClass('active')) {
      $('.ev-header,.ev-drawer').removeClass('active').addClass('hide');
    } else {
      $('.ev-header,.ev-drawer').removeClass('hide').addClass('active');
    }
    return false;
  });

  // ドロワータイトルクリックイベント
  $('.ev-drawer__title:not(.nochild)').click(function() {
    $(this).toggleClass('active');
    $(this).next('.ev-drawer__nav').slideToggle(300);
    return false;
  });

  // 検索アイコンクリックイベント
  $('.nav-icon__item--search').click(function() {
    $('.ev-search').addClass('active');
    return false;
  });

  $('.search__close').click(function() {
    $('.ev-search').removeClass('active');
    return false;
  });

  // フッタータイトルクリックイベント
  $('.ev-footer__title').click(function() {
    if (window.matchMedia("(max-width: 768px)").matches) {
      $(this).toggleClass('active');
      $(this).next('.ev-footer__nav').slideToggle(300);
      return false;
    }
  });

  // 改行でspanで分割
  const splits = document.querySelectorAll(".split");
  splits.forEach(split => {
    const text = split.dataset.text || "";

    const formattedText = text
      .split("\n")
      .map(line => `<div><span>${line}</span></div>`)
      .join("");

    split.innerHTML = formattedText;
  });

  function handleSlick($element) {
    if (window.matchMedia("(max-width: 768px)").matches) {
      if (!$element.hasClass('slick-initialized')) {
        $element.slick({
          dots: false,
          arrows: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
        });
      }
    } else if ($element.hasClass('slick-initialized')) {
      $element.slick('unslick');
    }
  }

  handleSlick($('.ev-topics .list-topics'));

  // ウィンドウリサイズ時にSlickを再適用
  $(window).on('resize', function() {
    handleSlick($('.ev-topics .list-topics'));
  });

  // Lenisの初期化
  const lenis = new Lenis({
    // Lenis設定（例）
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  let mm = gsap.matchMedia();

  //パララックス
  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray('.parallax').forEach(wrap => {
    const y = window.matchMedia("(max-width: 768px)").matches ? -48 : -120;

    gsap.to(wrap, {
      y: y,
      scrollTrigger: {
        trigger: wrap,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 0.5,
        //markers: true
      }
    });
  });

  const philosophyTrigger = ".ev-philosophy";
  const secStart = window.matchMedia("(max-width: 768px)").matches ? "top 50%" : "top 70%";
  const secDuration = 0.6;
  const philosophyDuration = 0.8;

  gsap.from("[data-word='caring']", {
    y: 20,
    scale: 0.9,
    opacity: 0,
    duration: philosophyDuration,
    scrollTrigger: {
      trigger: philosophyTrigger,
      start: secStart,
    }
  });

  gsap.from("[data-word='for']", {
    x: -20,
    scale: 0.9,
    opacity: 0,
    delay: 0.05,
    duration: philosophyDuration,
    scrollTrigger: {
      trigger: philosophyTrigger,
      start: secStart,
    }
  });

  gsap.from("[data-word='skin']", {
    y: -20,
    scale: 0.9,
    opacity: 0,
    delay: 0.1,
    duration: philosophyDuration,
    scrollTrigger: {
      trigger: philosophyTrigger,
      start: secStart,
    }
  });

  gsap.from("[data-word='and']", {
    x: -20,
    scale: 0.9,
    opacity: 0,
    delay: 0.15,
    duration: philosophyDuration,
    scrollTrigger: {
      trigger: philosophyTrigger,
      start: secStart,
    }
  });

  gsap.from("[data-word='earth']", {
    x: -20,
    scale: 0.9,
    opacity: 0,
    delay: 0.2,
    duration: philosophyDuration,
    scrollTrigger: {
      trigger: philosophyTrigger,
      start: secStart,
    }
  });

  gsap.from(".ev-featured .ev-featured__name span", {
    y: 50,
    scale: 0.8,
    opacity: 0,
    duration: secDuration,
    scrollTrigger: {
      trigger: '.ev-featured',
      start: secStart,
      toggleActions: "play none none none",
    }
  });

  if (document.querySelector(".ev-featured")) {
    ScrollTrigger.create({
      trigger: ".ev-featured",
      start: "top center",
      onEnter: () => {
        document.querySelector("#MainContent").classList.add("bg-white");
        document.querySelector(".ev-featured__image").classList.add("active");
      },
      onLeaveBack: () => {
        document.querySelector("#MainContent").classList.remove("bg-white");
      }
    });
  }

  // .ev-info が存在する場合のみ処理を実行
  if (document.querySelector(".ev-info")) {
    ScrollTrigger.create({
      trigger: ".ev-info",
      start: "bottom center",
      onEnter: () => document.querySelector("#MainContent").classList.remove("bg-white"),
      onLeaveBack: () => document.querySelector("#MainContent").classList.add("bg-white"),
    });
  }

  gsap.utils.toArray(".list-topics__item").forEach(topicsBlock => {
    gsap.from(topicsBlock.querySelector(".topics__image-mask"), {
      height: 0,
      duration: secDuration,
      scrollTrigger: {
        trigger: topicsBlock,
        start: secStart,
      }
    });
    gsap.from(topicsBlock.querySelector(".topics__title"), {
      y: 20,
      opacity: 0,
      duration: secDuration,
      delay: 0.3,
      scrollTrigger: {
        trigger: topicsBlock,
        start: secStart,
      }
    });
    gsap.from(topicsBlock.querySelector(".topics__date"), {
      y: 20,
      opacity: 0,
      duration: secDuration,
      delay: 0.6,
      scrollTrigger: {
        trigger: topicsBlock,
        start: secStart,
      }
    });
  });

  ScrollTrigger.create({
    trigger: ".ev-ingre",
    start: "top center",
    onEnter: () => {
      // .list-ingre__itemのimg要素を取得
      const images = gsap.utils.toArray(".list-ingre__item img");

      // 画像をランダムにフェードイン
      images.forEach(img => {
        // ランダムな遅延を設定
        const randomDelay = Math.random() * 1; // 0から0.5秒のランダムな遅延
        gsap.to(img, {
          opacity: 1,
          scale: 1,
          duration: 0.6,
          delay: randomDelay, // ランダムな遅延を適用
          scrollTrigger: {
            trigger: ".ev-ingre",
            start: "top center",
          }
        });
      });
    }
  });

  $('.list-cat__item').hover(
    function() {
      const newSrc = $(this).find('img.cat__image').attr('src');
      $(catImage).attr('src', newSrc);
    }
  );

  //スクロール移動
  var scrollElm = (function() {
    if ('scrollingElement' in document) {
      return document.scrollingElement;
    }
    if (navigator.userAgent.indexOf('WebKit') != -1) {
      return document.body;
    }
    return document.documentElement;
  })();

  $('a[href^="#"]').not('.nav-icon__item a,.link--popup,.ev-localnav a').on('click', function() {
    var windowwidth = $(window).width()
    var speed = 600;
    var easing = 'swing';
    var href = $(this).attr("href");
    $(scrollElm).animate({
      scrollTop: $(href == "#" ? 'html' : href).offset().top
    }, speed, easing);

    return false;
  });

  const boxes = document.querySelectorAll(".ev-itemlist");
  const firstNavLink = document.querySelector(".list-localnav li:first-child a");

  const options = {
    root: null,
    rootMargin: "-50% 0px",
    threshold: 0,
  };

  const observer = new IntersectionObserver(doWhenIntersect, options);
  boxes.forEach((box) => {
    observer.observe(box);
  });

  // スクロールが一番上の時に処理を行う
  window.addEventListener("scroll", () => {
    if (window.scrollY === 0) {
      setFirstNavActive();
    }
  });

  function doWhenIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        activateIndex(entry.target);
      }
    });
  }

  function activateIndex(element) {
    const currentActiveIndex = document.querySelector(".list-localnav .active");
    if (currentActiveIndex !== null) {
      currentActiveIndex.classList.remove("active");
    }

    const newActiveIndex = document.querySelector(`a[href='#${element.id}']`);
    if (newActiveIndex) {
      newActiveIndex.classList.add("active");
    }
  }

  // 最初のリンクにactiveクラスを追加
  function setFirstNavActive() {
    const currentActiveIndex = document.querySelector(".list-localnav .active");
    if (currentActiveIndex !== null) {
      currentActiveIndex.classList.remove("active");
    }
    if (firstNavLink) {
      firstNavLink.classList.add("active");
    }
  }


  // 商品一覧ナビゲーション
  mm.add("(min-width: 768px)", () => {

    gsap.fromTo(
      '.ev-localnav', { opacity: 0 }, {
        opacity: 1,
        duration: 0.3,
        ease: 'power1.out',
      });

    var targetHeight = $('.ev-localnav').innerHeight();
    var windowHeight = $(window).height();
    var adjHeight = (windowHeight - targetHeight) - 40;

    startHeight = 'top-=' + adjHeight;
    endHeight = 'bottom-=' + (targetHeight + adjHeight);
    gsap.to('.ev-localnav', {
      scrollTrigger: {
        trigger: '.ev-localnav',
        start: startHeight,
        endTrigger: '.ev-layout__item--main',
        end: endHeight,
        pin: true,
        markers: false
      }
    });
  });

  // 汎用固定
  mm.add("(min-width: 768px)", () => {
    const headerSelector = '.ev-layout__item--header:not(.ev-layout__item--header-topicsdetail):not(.ev-layout__item--header-infodetail) .ev-contents__header';
    var targetHeight = $(headerSelector).innerHeight();
    var windowHeight = $(window).height(); // ウィンドウの高さ
    var adjHeight = 60;

    if (targetHeight > windowHeight) {
      adjHeight = '-' + ((targetHeight - windowHeight) + 60);
    }
    startHeight = 'top-=' + adjHeight;
    endHeight = 'bottom-=' + (targetHeight + adjHeight);
    gsap.to(headerSelector, {
      scrollTrigger: {
        trigger: headerSelector,
        start: startHeight,
        endTrigger: '.ev-layout__item--contents',
        end: endHeight,
        pin: true,
        markers: false
      }
    });
  });

  // トピックス・インフォメーション固定
  mm.add("(min-width: 980px)", () => {
    const headerSelector = '.ev-layout__item--header-topicsdetail .ev-contents__header,.ev-layout__item--header-infodetail .ev-contents__header';
    var targetHeight = $(headerSelector).innerHeight();
    var windowHeight = $(window).height(); // ウィンドウの高さ
    var adjHeight = 60;

    if (targetHeight > windowHeight) {
      adjHeight = '-' + ((targetHeight - windowHeight) + 60);
    }
    startHeight = 'top-=' + adjHeight;
    endHeight = 'bottom-=' + (targetHeight + adjHeight);
    gsap.to(headerSelector, {
      scrollTrigger: {
        trigger: headerSelector,
        start: startHeight,
        endTrigger: '.ev-layout__item--contents',
        end: endHeight,
        pin: true,
        markers: false
      }
    });
  });

  // トピックス一覧カテゴリー固定
  mm.add("(max-width: 769px)", () => {
    const headerSelector = '.list-blogtag';
    var targetHeight = $(headerSelector).innerHeight();
    var windowHeight = $(window).height(); // ウィンドウの高さ
    var adjHeight = 40;

    if (targetHeight > windowHeight) {
      adjHeight = '-' + ((targetHeight - windowHeight) + 60);
    }
    startHeight = 'top-=' + adjHeight;
    endHeight = 'bottom-=' + (targetHeight + adjHeight);
    gsap.to(headerSelector, {
      scrollTrigger: {
        trigger: headerSelector,
        start: startHeight,
        endTrigger: '.ev-layout__item--contents',
        end: endHeight,
        pin: true,
        markers: false
      }
    });
  });

  // イングリーディエント固定
  mm.add("(min-width: 768px)", () => {
    const headerSelector = '.ev-ingredients__contents-inner';
    var targetHeight = $(headerSelector).innerHeight();
    var windowHeight = $(window).height(); // ウィンドウの高さ
    var adjHeight = 60;

    if (targetHeight > windowHeight) {
      adjHeight = '-' + ((targetHeight - windowHeight) + 60);
    }
    startHeight = 'top-=' + adjHeight;
    endHeight = 'bottom-=' + (targetHeight + adjHeight);
    gsap.to(headerSelector, {
      scrollTrigger: {
        trigger: headerSelector,
        start: startHeight,
        endTrigger: '.ev-ingredients__header',
        end: endHeight,
        pin: true,
        markers: false
      }
    });
  });

  var hoverTimeout;

  $('.ev-ingredients__index').hover(
    function() {
      if ($(this).hasClass('active')) {
        return;
      } else {
        if ($(window).width() >= 769) {
          hoverTimeout = setTimeout(() => {
            $('.ev-ingredients__index').removeClass('active');
            $(this).addClass('active');

            var detail = $(this).next('.ev-ingredients__detail').html();

            $('.ev-ingredients__contents-inner').fadeOut(100, function() {
              $(this).html(detail);
              $(this).fadeIn(300);
              ScrollTrigger.refresh
            });
          }, 100);
        }
      }
    },
    function() {
      clearTimeout(hoverTimeout);
    }
  );

  $('.ev-ingredients__index').click(function() {
    if ($(this).hasClass('active')) {
      if ($(window).width() <= 768) {
        $('.ev-ingredients__index').removeClass('active');
        $('.ev-ingredients__detail').slideUp();
      }
    } else {
      if ($(window).width() <= 768) {
        $('.ev-ingredients__index').removeClass('active');
        $('.ev-ingredients__detail').slideUp(400);
        $(this).addClass('active');

        setTimeout(() => {
          $(scrollElm).animate({
            scrollTop: $(this).offset().top
          }, 600, 'swing');
          $(this).next('.ev-ingredients__detail').slideDown();
        }, 400);



      }
    }
  });

  if ($(window).width() >= 769) {
    $('#AtoG .ev-ingredients__index').removeClass('active');
    
    $('#AtoG .ev-ingredients__index').filter(function() {
       return $(this).text().trim() !== ''; 
    }).first().addClass('active');
  
    var firstDetail = $('#AtoG .ev-ingredients__index.active').next('.ev-ingredients__detail').html();
    if (firstDetail) {
      $('.ev-ingredients__contents-inner').html(firstDetail).show();
    }
  }


  var adjHeight = 30;

  // 商品詳細サムネイル
  mm.add("(min-width: 768px)", () => {
    var targetHeight = $('.list-thumb').innerHeight();

    startHeight = 'top-=' + adjHeight;
    endHeight = 'bottom-=' + (targetHeight + adjHeight);
    gsap.to('.list-thumb', {
      scrollTrigger: {
        trigger: '.list-thumb',
        start: startHeight,
        endTrigger: '.ev-layout__item--gallery',
        end: endHeight,
        pin: true,
        markers: false
      }
    });
  });

  // 商品詳細説明
  mm.add("(min-width: 768px)", () => {
    var targetHeight = $('.ev-product-info').innerHeight();

    startHeight = 'top-=' + adjHeight;
    endHeight = 'bottom-=' + (targetHeight + adjHeight);
    gsap.to('.ev-product-info', {
      scrollTrigger: {
        trigger: '.ev-product-info',
        start: startHeight,
        endTrigger: '.ev-layout__item--gallery',
        end: endHeight,
        pin: true,
        markers: false
      }
    });
  });

  // faqクリックイベント
  $('.faq__title').click(function() {
    $(this).toggleClass('active');
    $(this).next('.faq__desc').slideToggle();
    return false;
  });

  // 商品詳細popup
  $('.link--popup').click(function() {
    $('.popup__item').hide()
    $(this).parents('.popup').find('.popup__item').fadeToggle(300);
    return false;
  });

  $('.popup__close').click(function() {
    $('.popup__item').fadeOut(300);
    return false;
  });

  $(window).on('scroll', function() {
    //$('.popup__item').fadeOut(300);
  });

  // toggledown
  $('.toggledown__title').click(function() {
    $(this).toggleClass('active');
    $(this).next('.toggledown__contents').slideToggle(300);
    setTimeout(() => {
      ScrollTrigger.refresh();
      updateScrollTriggers();
    }, 300);
    return false;
  });

  function moveGallery() {
    if ($(window).width() <= 768) {
      if (!$('.list-gallery').parent().is('.ev-layout__item--iteminfo')) {
        $('.ev-layout__item--iteminfo').prepend($('.list-gallery'));
      }
      if (!$('.list-gallery').hasClass('slick-initialized')) {
        $('.list-gallery').slick({
          // ここにslickのオプションを追加
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        });
      }
    } else {
      if (!$('.list-gallery').parent().is('.ev-layout__item--gallery')) {
        $('.ev-layout__item--gallery').prepend($('.list-gallery'));
      }
      if ($('.list-gallery').hasClass('slick-initialized')) {
        $('.list-gallery').slick('unslick');
      }
    }
  }

  // 初期呼び出し
  moveGallery();

  // ウィンドウサイズが変更されたときに呼び出し
  $(window).resize(function() {
    moveGallery();
  });

  // すべてのリストアイテム（aタグ）を取得
  const thumbItems = document.querySelectorAll(".list-thumb__item");

  // 各リストアイテムのhrefからターゲットIDを取得
  thumbItems.forEach((item) => {
    const href = item.getAttribute("href");
    if (href && href.startsWith("#")) {
      const target = document.querySelector(href); // ID要素を取得

      if (target) {
        // ScrollTriggerを設定
        gsap.timeline({
          scrollTrigger: {
            trigger: target,
            start: "top center", // ターゲットの上端がビューポートの中央に来た時
            end: "bottom center", // ターゲットの下端がビューポートの中央に来た時
            onEnter: () => item.classList.add("active"), // 表示領域に入ったらクラスを追加
            onLeave: () => item.classList.remove("active"), // 表示領域から外れたらクラスを削除
            onEnterBack: () => item.classList.add("active"), // スクロールバック時もクラスを追加
            onLeaveBack: () => item.classList.remove("active"), // スクロールバック時にクラスを削除
            markers: false // デバッグ用にtrueで可視化可能
          }
        });
      }
    }
  });

  // 商品写真ズームアウト
  gsap.utils.toArray(".list-gallery__item img").forEach((img) => {
    gsap.fromTo(
      img, { scale: 1.1 }, // 初期状態（ズームイン）
      {
        scale: 1, // ズームアウトする状態
        duration: 2, // アニメーションの時間
        ease: "power2.out",
        scrollTrigger: {
          trigger: img, // imgがトリガー
          start: "top 80%", // トリガー開始位置
          end: "top 50%", // トリガー終了位置
          toggleActions: "play none none none", // アクション設定
        },
      }
    );
  });

  //せり上がりアニメーション
  gsap.utils.toArray('.template-collection .item__name div,.template-collection .item__copy div,.template-collection .variant__item table,.template-collection .item__status span,.ev-itemlist__title-en div,.ev-itemlist__copy div,.item__name--l h1').forEach((element) => {
    gsap.fromTo(
      element, {
        y: 30, // 下からスタート
        opacity: 0, // 非表示からスタート
      }, {
        y: 0, // 元の位置へ
        opacity: 1, // 完全に表示
        duration: 0.6, // アニメーション時間
        ease: "power2.out", // イージング
        scrollTrigger: {
          trigger: element, // 要素をトリガー
          start: "top 80%", // ビューポートの80%下でトリガー
          toggleActions: "play none none none", // 再生のみ
          markers: false, // デバッグ用のマーカーはオフ
        },
      }
    );
  });

  //企業情報ページの背景
  gsap.to(".ev-company__bg img", {
    scale: 1.3,
    ease: "none",
    scrollTrigger: {
      trigger: "body",
      start: "top top",
      end: "bottom bottom",
      scrub: true,
    },
  });

  // .ev-layout__title のアニメーション
  gsap.utils.toArray('.ev-layout__title span').forEach((element) => {
    gsap.fromTo(
      element, {
        y: 100, // 下にオフセット
        opacity: 0, // 非表示からスタート
        scale: 1.1
      }, {
        y: 0, // 元の位置に戻る
        opacity: 1, // 完全に表示
        scale: 1,
        duration: 0.8, // アニメーション時間
        ease: "power2.out", // イージング
      }
    );
  });

  // ALL PRODUCTSのSPメニュー
  $('.ev-localnav__title').click(function() {
    $(this).parents('.ev-localnav').toggleClass('active');
  });

  $('.list-localnav__item a').click(function() {
    var windowwidth = $(window).width()
    var speed = 600;
    var easing = 'swing';
    var href = $(this).attr("href");
    $(scrollElm).animate({
      scrollTop: $(href == "#" ? 'html' : href).offset().top
    }, speed, easing);
    $(this).parents('.ev-localnav').removeClass('active');

    return false;
  });

  mm.add("(max-width: 768px)", () => {
    gsap.to(".ev-localnav", {
      opacity: 0, // フェードアウト
      duration: 0.3, // アニメーション時間
      scrollTrigger: {
        trigger: ".ev-footer", // トリガー要素
        start: "top bottom", // .ev-footer の上端がビューポートの下端に到達した時
        toggleActions: "play none none reverse", // フェードイン/フェードアウトを繰り返す
        markers: false // デバッグ用マーカー（必要ならtrueに設定）
      }
    });
  });

  //パスワードページのログインフォーム表示
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('evolve')) {
    $('.ev-comingsoon__form').show();
  }

  //パスワード表示
  $('.pass__view').click(function() {
    var $target = $(this).parents('.pass').find('input');
    $(this).toggleClass('active');

    if ($target.attr('type') === 'text') {
      $target.attr('type', 'password');
    } else {
      $target.attr('type', 'text');
    }
  });

  //
  $('.ev-artisan__slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    fade: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $('.select-subnav select').on('change', function() {
    var selectedValue = $(this).val();
    if (selectedValue == 'all') {
      $('.ev-stockist').fadeIn(300);
    } else {
      $('.ev-stockist:not(#popupstore)').hide();
      var target = $('#' + selectedValue);
      target.fadeIn(300, function() {
          $('html, body').animate({
              scrollTop: target.offset().top - 30
          }, 500);
      });
    }
  });
  
  //商品ホバーの動画再生
  $('.list-products__item, .ev-featured__item').on('mouseenter touchstart', function () {
    const video = $(this).find('.item__image-second video').get(0);
    if (video) {
      video.play();
    }
  });
  
  $('.list-products__item, .ev-featured__item').on('mouseleave touchend', function () {
    const video = $(this).find('.item__image-second video').get(0);
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });

});